var _rect, _line, _line2, _line3, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentWithCrossGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 9,
    height: 11,
    rx: 1.5,
    stroke: "#747B8B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 8.5,
    x2: 9.5,
    y2: 8.5,
    stroke: "#747B8B",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 6.5,
    x2: 9.5,
    y2: 6.5,
    stroke: "#747B8B",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 4.5,
    x2: 9.5,
    y2: 4.5,
    stroke: "#747B8B",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    fill: "white",
    stroke: "#747B8B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34203 5.59032C2.15313 5.3878 2.12592 5.09771 2.28125 4.94238L4.90073 2.3229C5.05606 2.16757 5.33511 2.20582 5.52401 2.40834C5.71291 2.61086 5.74012 2.90095 5.58479 3.05628L2.96531 5.67576C2.80998 5.83109 2.53092 5.79284 2.34203 5.59032Z",
    fill: "#747B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34205 2.36669C2.53095 2.16417 2.81 2.12592 2.96533 2.28125L5.58481 4.90073C5.74014 5.05606 5.71293 5.34615 5.52403 5.54867C5.33514 5.75118 5.05609 5.78944 4.90076 5.63411L2.28128 3.01462C2.12595 2.85929 2.15316 2.5692 2.34205 2.36669Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWithCrossGrey);
export default __webpack_public_path__ + "static/media/document-with-cross-grey.7814934ec8bbd71775e092a98f164413.svg";
export { ForwardRef as ReactComponent };